import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  CapabilityExecutionStatus,
  CapabilityExecutionsResponseDataSchema,
  DataResponseWithPagination,
} from "schema"
import z from "zod"

type Response = DataResponseWithPagination<z.infer<typeof CapabilityExecutionsResponseDataSchema>>

export type CapabilityExecutionsFilters = {
  campaignId?: string
  status?: CapabilityExecutionStatus
  conversationType?: "Live" | "Testing"
  rangeDays?: 7 | 30
}

const getCapabilityExecutionsQueryKey = (
  id?: string,
  page?: number,
  total?: number,
  filters?: CapabilityExecutionsFilters,
) => ["capabilityExecutions", id, page, total, filters]

type Params = {
  id: string
  page?: number
  total?: number
  filters?: CapabilityExecutionsFilters
  onSuccess?: (data: Response) => void
}

export const capabilityExecutionsQuery = (params?: Params) => {
  return queryOptions({
    queryKey: getCapabilityExecutionsQueryKey(
      params?.id,
      params?.page,
      params?.total,
      params?.filters,
    ),
    queryFn: async () => {
      if (!params?.id) {
        return { data: [], pageInfo: { count: 0 } }
      }

      const response = await axios.get<Response>(`/capabilities/${params.id}/executions`, {
        params: {
          page: params.page,
          total: params.total,
          campaignId: params.filters?.campaignId,
          status: params.filters?.status,
          conversationType: params.filters?.conversationType,
          rangeDays: params.filters?.rangeDays ?? 7,
        },
      })

      if (params?.onSuccess) {
        params.onSuccess(response.data)
      }

      return response.data
    },
    enabled: !!params?.id,
  })
}
